import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type CongressViewMode = 'drawer' | 'expand';

const STORAGE_KEY = 'planwise-congress-view-mode';

@Injectable({
  providedIn: 'root',
})
export class CongressViewPreferenceService {
  private modeSubject: BehaviorSubject<CongressViewMode>;
  mode$;

  constructor() {
    const stored = localStorage.getItem(STORAGE_KEY) as CongressViewMode | null;
    this.modeSubject = new BehaviorSubject<CongressViewMode>(stored === 'expand' ? 'expand' : 'drawer');
    this.mode$ = this.modeSubject.asObservable();
  }

  get mode(): CongressViewMode {
    return this.modeSubject.value;
  }

  setMode(mode: CongressViewMode): void {
    this.modeSubject.next(mode);
    localStorage.setItem(STORAGE_KEY, mode);
  }

  toggle(): void {
    this.setMode(this.mode === 'drawer' ? 'expand' : 'drawer');
  }
}
